import React from 'react';
import { PiFolderOpenLight } from 'react-icons/pi';
import type { AppDispatch } from '../../store';
import {
  addProjectCollaborator,
  removeProjectCollaborator,
  updateProjectCollaboratorAccess,
  fetchProjectResources,
} from '../../store/actions/Projects/ProjectActions';
import type { CollaboratorAdapter } from './types';

interface BuildProjectAdapterArgs {
  projectUuid: string;
  collaborators: any[];
  currentUserUuid?: string;
  canAdmin?: boolean;
  onUpdate?: () => void;
  subMessage?: string;
}

export const buildProjectCollaboratorAdapter = (
  dispatch: AppDispatch,
  {
    projectUuid,
    collaborators,
    currentUserUuid,
    canAdmin,
    onUpdate,
    subMessage,
  }: BuildProjectAdapterArgs
): CollaboratorAdapter => ({
  resourceUuid: projectUuid,
  resourceType: 'project',
  collaborators,
  currentUserUuid,
  canAdmin,
  onUpdate: () => {
    dispatch(fetchProjectResources(projectUuid));
    onUpdate?.();
  },
  addCollaborator: (uuid, userIdOrUuid, access) =>
    dispatch(addProjectCollaborator(uuid, userIdOrUuid, access)) as unknown as Promise<any>,
  removeCollaborator: (uuid, collaboratorUuid) =>
    dispatch(removeProjectCollaborator(uuid, collaboratorUuid)) as unknown as Promise<any>,
  updateAccess: (uuid, collaboratorUuid, access) =>
    dispatch(
      updateProjectCollaboratorAccess(uuid, collaboratorUuid, access)
    ) as unknown as Promise<any>,
  icon: React.createElement(PiFolderOpenLight, { className: 'w-5 h-5' }),
  subMessage,
});
